import React from 'react';
import { IconProps } from '.';

const SvgColoredStar = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#FFC700'
        d='M12.718 1.647a.8.8 0 0 0-1.435 0L8.379 7.53l-6.494.95a.8.8 0 0 0-.443 1.364l4.699 4.576-1.11 6.466a.8.8 0 0 0 1.162.843L12 18.675l5.808 3.054a.8.8 0 0 0 1.16-.843L17.86 14.42l4.698-4.576a.8.8 0 0 0-.442-1.365l-6.494-.95-2.904-5.882Z'
      />
    </svg>
  );
};

export default SvgColoredStar;
